module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-navbar"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "router": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "a"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Informazioni Generali")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/citta"
    }
  }, [_vm._v("Città di Napoli")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/sede"
    }
  }, [_vm._v("Sede del congresso")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/premi"
    }
  }, [_vm._v("Premi")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/ecm"
    }
  }, [_vm._v("ECM")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "b"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Iscrizioni")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/quote"
    }
  }, [_vm._v("Modalità di iscrizione")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/comitati/comitati"
    }
  }, [_vm._v("Comitati")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "c"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Programma")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-c",
    attrs: {
      "index": "/inside/programma/presto-disponibile"
    }
  }, [_vm._v("Presto disponibile")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/abstract/abstract"
    }
  }, [_vm._v("Abstract")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/info-generali/prenotazione-alberghiera"
    }
  }, [_vm._v("Prenotazione Alberghiera")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "f"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Aziende")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/aziende/sponsor"
    }
  }, [_vm._v("Sponsor")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "iscrizioni"
    }
  }, [_vm._v("Iscrizioni")])], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d50e8ed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-navbar.vue
// module id = 616
// module chunks = 2